module.exports = __webpack_public_path__ + "img/swper3.8084b1ce.png";